import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source"]
  static values = {
    successMessage: String,
    errorMessage: String
  }

  copy(event) {
    event.preventDefault()

    const text = this.sourceTarget.textContent.trim()
    const button = event.currentTarget

    navigator.clipboard.writeText(text).then(() => {
      // Показываем успешное сообщение
      this.showFeedback(button, true)
      // Показываем flash-уведомление
      toastr['success']('Ключ скопирован в буфер обмена', '', toastOptions)
    }).catch(err => {
      // Показываем ошибку
      this.showFeedback(button, false)
      toastr['error']('Не удалось скопировать ключ', '', toastOptions)
      console.error('Failed to copy text: ', err)
    })
  }

  showFeedback(button, success) {
    const originalHTML = button.innerHTML
    const originalClass = button.className

    if (success) {
      button.innerHTML = '<i class="bi bi-check"></i>'
      button.classList.remove('btn-outline-secondary')
      button.classList.add('btn-success')
    } else {
      button.innerHTML = '<i class="bi bi-x"></i>'
      button.classList.remove('btn-outline-secondary')
      button.classList.add('btn-danger')
    }

    setTimeout(() => {
      button.innerHTML = originalHTML
      button.className = originalClass
    }, 2000)
  }
}
